import { useT } from "@/i18n";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_d216ca66-0733-41eb-aefb-a68564ba10f0/artifacts/fn20k37z_FINAL%20Logo%20Newsky%20png.png";

export default function Footer() {
  const t = useT();

  const footerLinks = [
    { label: t.nav.plans, href: "#planos" },
    { label: t.nav.howItWorks, href: "#como-funciona" },
    { label: t.nav.contact, href: "#contato" },
    { label: t.nav.support, href: "/support" },
  ];

  const handleClick = (e, href) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer data-testid="footer" className="border-t border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <a href="/" className="flex items-center">
            <img src={LOGO_URL} alt="NewSky Mobile" className="h-8 w-auto" />
          </a>
          <div className="flex flex-wrap items-center justify-center gap-6">
            {footerLinks.map((link) => (
              <a key={link.label} href={link.href} onClick={(e) => handleClick(e, link.href)} className="text-sm text-slate-500 hover:text-slate-300 transition-colors">{link.label}</a>
            ))}
          </div>
          <p className="text-sm text-slate-600">&copy; {new Date().getFullYear()} NewSky Mobile</p>
        </div>
      </div>
    </footer>
  );
}
